import React from 'react';
import { WizzardWorkspaceModal } from './WizzardWorkspaceModal';
import { useStateSelector } from 'src/redux';
import useActionsApp from 'src/redux/actionHooks/useActionsApp';
import useWzardInit from './useWzardInit';
import { useCache } from 'src/graphql';

export const WizzardWorkspace = () => {
  const wizardWorkspace = useStateSelector(({ app }) => app.wizardWorkspace);
  const { setWizardWorkspace } = useActionsApp();
  const { refetchQuery } = useCache();

  const { wizardValues, isLoading, isStdVarComplete } = useWzardInit();

  if (wizardWorkspace)
    return (
      <WizzardWorkspaceModal
        wizardData={wizardValues}
        isLoading={isLoading}
        isStdVarComplete={isStdVarComplete}
        onClose={() => {
          setWizardWorkspace(null);
          refetchQuery({ include: ['wizard'] });
        }}
      />
    );

  return null;
};
